// @flow
import * as React from 'react'
/*:: import type {ComponentType} from 'react' */
import styled from 'styled-components'
import {translate} from 'react-i18next'
import {
  Banner,
  Link,
  SplitSection,
  SectionImage,
  SectionContent,
  SectionTitle,
  styles
} from 'tutellus-ui'

import {Page} from './Page'

const LearnSection = styled(SplitSection)`
    & > ${SectionContent} {
        & > ${SectionImage} {
            max-width: 50%;
            @media ${styles.media.tablet} {
                max-width: 80%;
            }
        }
    }
`
LearnSection.displayName = 'LearnSection'

const TeachSection = styled(SplitSection)`
    & > ${SectionContent} {
        & > ${SectionImage} {
            @media ${styles.media.tablet} {
                max-width: 100%;
            }
            @media ${styles.media.laptop} {
                max-width: 70%;
            }
        }
    }
`
TeachSection.displayName = 'TeachSection'

const PromoteSection = styled(SplitSection)`
    & > ${SectionContent} {
        & > ${SectionImage} {
            max-width: 50%;
            @media ${styles.media.tablet} {
                max-width: 90%;
            }
            @media ${styles.media.laptop} {
                max-width: 70%;
            }
            @media ${styles.media.desktop} {
                margin-top: -7em;
            }
        }
    }
`
PromoteSection.displayName = 'PromoteSection'

const TechSection = styled(SplitSection)`
    & > ${SectionContent} {
        grid-gap: 2em 1em;
        & > ${SectionImage} {
            max-width: 50%;
            @media ${styles.media.tablet} {
                max-width: 80%;
            }
        }
    }
`
TechSection.displayName = 'TechSection'

export const HowItWork = translate('howItWorks')(({t}) =>
  <Page>
    <Banner background_url={t('background_url')}
      title={t('title')}>
      { t('description') }
    </Banner>
    <LearnSection reverse
      align='bottom'
      title={t('learn_title')}
      image={t('learn_image')}>
      <p>{ t('learn_description') }</p>
    </LearnSection>
    <TeachSection light
      title={t('teach_title')}
      image={t('teach_image')}>
      <p>{ t('teach_description') }</p>
    </TeachSection>
    <PromoteSection reverse
      align='bottom'
      overflow='top'
      title={t('promote_title')}
      image={t('promote_image')}>
      <p>{ t('promote_description') }</p>
    </PromoteSection>
    <TechSection dark
      align='bottom'
      title={<SectionTitle dangerouslySetInnerHTML={{__html: t('tech_title')}} />}
      image={t('tech_image')}>
      <SectionTitle.h4 center={false} simple>
        { t('tech_products_title')}
      </SectionTitle.h4>
      <p>{ t('tech_products_description')}</p>
      <SectionTitle.h4 center={false} simple>
        { t('tech_multiple_title')}
      </SectionTitle.h4>
      <p>{ t('tech_multiple_description')}</p>
      <Link button primary
        href={t('urls:register')}
      >
        { t('tech_cta') }
      </Link>
    </TechSection>
  </Page>
)
HowItWork.displayName = 'HowItWork'



// WEBPACK FOOTER //
// ./src/pages/HowItWork.js